import API from "@utils/request";
import { navigate } from "@utils";

import { FILE_ROOT, pathLoac } from "@config";

let Language = localStorage.getItem('currentLanguage');  //获取本地语言
let prout = 'protal';
if (!Language || Language == 'zh') {

} else {
    prout = 'protal_' + Language;
}



export async function getcommonData(params) {
    try {
        return await API.post("api/" + prout + "/api/index/commonData", params);
    } catch (error) {
        return error;
    }
}

// 首页banner列表
export async function getBanner(params) {
    try {
        return await API.post("api/" + prout + "/api/banner/list", params);
    } catch (error) {
        return error;
    }
}


// 活动列表（近期活动、精彩活动、时间线）
export async function getactivityList(params) {
    try {
        return await API.post("api/" + prout + "/api/index/activityList", params);
    } catch (error) {
        return error;
    }
}


// 话题列表

export async function gettopicList(params) {
    try {
        return await API.post("api/" + prout + "/api/index/topicList", params);
    } catch (error) {
        return error;
    }
}

// 热门帖子
export async function getpostList(params) {
    try {
        return await API.post("api/" + prout + "/api/index/postList", params);
    } catch (error) {
        return error;
    }
}
export async function getlivelyUserList(params) {
    try {
        return await API.post("api/" + prout + "/api/index/livelyUserList", params);
    } catch (error) {
        return error;
    }
}

// 添加帖子  

export async function addApipost(params) {
    try {
        return await API.post("api/" + prout + "/api/post/add", params);
    } catch (error) {
        return error;
    }
}

// 用户反馈

export async function getFeedBack(params) {
    try {
        return await API.post("api/" + prout + "/api/index/feedBack", params);
    } catch (error) {
        return error;
    }
}

// 登录的个人信息user/getMyInfo
export async function getMyInfo(params) {
    try {
        let ress = await API.post("api/" + prout + "/api/user/getMyInfo", params);
        //获取当前的路由地址
        const currentRoute = window.location.pathname;
        if (ress.status == 200) {
            //没有注册过用户信息，需要跳转到完善资料页面
            if (ress.data && ress.data.is_edit == 2) {
                if (!currentRoute.includes('information')) {
                    let str = "/cn";
                    let Language = localStorage.getItem("currentLanguage"); //获取本地语言

                    // 判断语言
                    if (Language && Language != "zh") {
                        str = "/" + Language;
                    }
                    // 补全地址
                    let urls = pathLoac + str + '/information?callback=' + currentRoute;
                    //    跳转
                    window.location.href = urls;
                     // navigate('/information?callback=' + currentRoute);
                }
               
            }
        }
        return ress;
    } catch (error) {
        return error;
    }
}

async function homeGetMyInfo(params) {
    try {
        return await API.post("api/" + prout + "/api/user/getMyInfo", params);
    } catch (error) {
        return error;
    }
}

// 关注用户

export async function setuserfollowAdd(params) {
    try {
        return await API.post("api/" + prout + "/userfollow/add", params);
    } catch (error) {
        return error;
    }
}

// 获取当前站点信息
export async function getCurrSiteData(params) {
    try {
        return await API.post("api/" + prout + "/api/index/currSiteData", params);
    } catch (error) {
        return error;
    }
}

// /
export async function editFrontmessage(params) {
    try {
        return await API.post("api/" + prout + "/frontmessage/edit", params);
    } catch (error) {
        return error;
    }
}


/**
 * 检测用户资料是否满足 报名、发话题文章
 * @param {number} id
 */
export async function userDataLv2(params) {
    try {
        return await API.post("api/" + prout + "/api/user/userDataLv2", params);
    } catch (error) {
        return error;
    }
}
/**
 * 全局搜索
 * @param {number} id
 */
export async function globalSearch(params) {
    try {
        return await API.post("api/" + prout + "/api/search/index", params);
    } catch (error) {
        return error;
    }
}
  
